import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { usePostMessageApi } from '../../../_hooks/usePostMessageApi';
import { Language } from '../../../_translations/Language';
import { isKbcIos } from '../../../_utils/initializeHelper';
import Question from '../../../examination/question/Question';
import ExampleQuestion from '../../../example-question/ExampleQuestion';
import Result from '../../../result/Result';
import ResultQuestion from '../../../result-question/ResultQuestion';
import StartScreen from '../../../startscreen/StartScreen';
import ExaminationLayoutMenu from '../examinationlayout-menu/ExaminationLayoutMenu';

import '../layout.scss';

const AuthorizedLayout: FC = () => {
  const locale = Language.getLocale() || 'nl';
  const { sendEmail, openUrl } = usePostMessageApi();

  return (
    <div className="authorized-layout">
      <ExaminationLayoutMenu />
      <Switch>
        <Route component={StartScreen} exact path="/start" />
        <Route component={ExampleQuestion} path="/example-question" />
        <Route component={Question} path="/examination" />
        <Route component={Result} path="/result" />
        <Route component={ResultQuestion} path="/result-questions" />
        <Redirect to="/start" />
      </Switch>
      <div className="disclaimer">
        © {new Date().getFullYear()}
        <>
          <span onClick={() => openUrl(`https://www.vab.be/${locale}/rijschool`)}>VAB Rijschool nv</span>- Alle rechten
          voorbehouden -<span onClick={() => openUrl(`https://www.vab.be/${locale}/disclaimer/`)}>Disclaimer</span>-
          <span onClick={() => openUrl(`https://www.vab.be/${locale}/privacy/`)}>Privacy</span>
        </>
        -
        {isKbcIos() ? (
          <span onClick={() => sendEmail('proefexamen@vabrijschool.be')}>Contact</span>
        ) : (
          <a href="mailto: proefexamen@vabrijschool.be" rel="noopener noreferrer" target="_blank">
            Contact
          </a>
        )}
      </div>
    </div>
  );
};

export default AuthorizedLayout;
